import React, { useState, useEffect } from 'react';

export default function TankerFillingFlow() {
  const [current, setCurrent] = useState(1);
  const totalSlides = 5;

  const changeSlide = (dir) => {
    setCurrent((prev) => {
      let next = prev + dir;
      if (next < 1) return totalSlides;
      if (next > totalSlides) return 1;
      return next;
    });
  };

  const goToSlide = (n) => {
    setCurrent(n);
  };

  // Handle Keyboard & Touch Swipes
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowRight' || e.key === ' ') {
        e.preventDefault();
        changeSlide(1);
      }
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        changeSlide(-1);
      }
    };

    let touchStartX = 0;
    const handleTouchStart = (e) => {
      touchStartX = e.touches[0].clientX;
    };
    const handleTouchEnd = (e) => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        changeSlide(diff > 0 ? 1 : -1);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('touchstart', handleTouchStart);
    document.addEventListener('touchend', handleTouchEnd);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, []);

  // Handle slide animations EXACTLY like vanilla JS
  useEffect(() => {
    window.scrollTo(0, 0);
    const activeSlide = document.querySelector(`.slide[data-slide="${current}"]`);
    if (activeSlide) {
      const reveals = activeSlide.querySelectorAll('.reveal');
      reveals.forEach((el, i) => {
        el.style.transition = 'none';
        el.style.opacity = '0';
        el.style.transform = 'translateY(20px)';
        
        // Force reflow
        void el.offsetHeight;
        
        const delay = i * 0.08;
        el.style.transition = `opacity 0.35s ease ${delay}s, transform 0.35s ease ${delay}s`;
        el.style.opacity = '1';
        el.style.transform = 'translateY(0px)';
      });
    }
  }, [current]);

  return (
    <>
      {/* Tailwind CDN & Fonts Injection for proper styling without external config */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
      <link href="https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;700;800&family=Playfair+Display:wght@700;800&display=swap" rel="stylesheet" />
      <script src="https://cdn.jsdelivr.net/npm/@tailwindcss/browser@4"></script>
      
      <style type="text/tailwindcss" dangerouslySetInnerHTML={{ __html: `
        @theme {
          --color-bg: #f7fafc;
          --color-bg-deep: #e8f1f4;
          --color-surface: #ffffff;
          --color-text: #102a43;
          --color-text-secondary: #334e68;
          --color-text-muted: #627d98;
          --color-accent-1: #0f766e;
          --color-accent-2: #38bdf8;
          --color-accent-3: #f59e0b;
          --color-glass-bg: rgba(255,255,255,0.86);
          --color-glass-border: rgba(15,23,42,0.08);
          --color-vignette: rgba(0,0,0,0.05);
          --font-display: 'Playfair Display', serif;
          --font-body: 'Manrope', sans-serif;
        }
      `}} />

     

      <style dangerouslySetInnerHTML={{ __html: `
        :root { --color-bg: #f7fafc; --color-text: #102a43; --glow-color-rgb: 15,118,110; }
        *, *::before, *::after { box-sizing: border-box; }
        
        html { background: var(--color-bg); margin: 0; }
        body { font-family: 'Manrope', sans-serif; color: var(--color-text); overflow-x: hidden; overflow-y: auto; min-height: 100vh; width: 100vw; margin: 0; }
        
        .deck { width: 100vw; position: relative; min-height: 100vh; }

         .active {
          border-radius: 0px !important;
        }
        
        .slide {
          position: absolute;
          inset: 0;
          background: var(--color-bg);
          display: none;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          padding-top: 40px;
          padding-bottom: 100px;
          opacity: 0;
          transform: scale(0.97);
          transition: opacity .7s ease, transform .7s ease;
          pointer-events: none;
          min-height: 100vh;
          overflow-y: auto;
        }
        
        .slide.active {
          display: flex;
          opacity: 1;
          transform: scale(1);
          pointer-events: all;
          position: relative;
        }
        
        .slide > .content { position: relative; z-index: 2; width: 100%; max-width: 1180px; padding: clamp(1.5rem, 4vw, 3.5rem); }
        .nav-controls { position: fixed; bottom: 24px; left: 50%; transform: translateX(-50%); display: flex; align-items: center; gap: 14px; z-index: 100; background: rgba(255,255,255,.88); backdrop-filter: blur(12px); padding: 10px 20px; border-radius: 999px; border: 1px solid rgba(15,23,42,.08); box-shadow: 0 8px 24px rgba(15,23,42,.08); }
        .nav-btn { width: 40px; height: 40px; border: none; background: rgba(15,118,110,.08); color: #0f766e; border-radius: 999px; font-size: 1.15rem; cursor: pointer; }
        .slide-dots { display: flex; gap: 8px; }
        .slide-dots .dot { width: 10px; height: 10px; border-radius: 50%; background: rgba(15,23,42,.12); cursor: pointer; transition: .25s; }
        .slide-dots .dot.active { background: #0f766e; transform: scale(1.25); }
        .slide-counter { font-size: .85rem; color: #627d98; min-width: 42px; text-align: center; }
        .reveal { opacity: 0; transform: translateY(20px); }
        .gradient-mesh { position: absolute; inset: 0; z-index: 0; overflow: hidden; pointer-events: none; }
        .blob { position: absolute; border-radius: 50%; filter: blur(80px); animation: float-slow 14s ease-in-out infinite; }
        .blob:nth-child(2) { animation-duration: 18s; }
        .blob:nth-child(3) { animation-duration: 22s; }
        @keyframes float-slow { 0%,100% { transform: translate(0,0) scale(1);} 33% { transform: translate(40px,-30px) scale(1.08);} 66% { transform: translate(-24px,28px) scale(.94);} }
        .slide::before { content:''; position:absolute; inset:0; z-index:1; pointer-events:none; background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.05'/%3E%3C/svg%3E"); opacity:.03; }
        .flow-grid { display:grid; grid-template-columns: repeat(3, 1fr); gap: 18px; margin-top: 24px; }
        .flow-card { background: rgba(255,255,255,.88); border: 1px solid rgba(15,23,42,.08); border-radius: 22px; padding: 18px; box-shadow: 0 10px 28px rgba(15,23,42,.06); min-height: 150px; position: relative; }
        .flow-card .num { width: 34px; height: 34px; border-radius: 999px; display:flex; align-items:center; justify-content:center; background: linear-gradient(135deg,#0f766e,#38bdf8); color:white; font-weight:800; margin-bottom:10px; }
        .arrow-note { position:absolute; right:-10px; top:50%; transform: translateY(-50%); color:#0f766e; font-size:24px; font-weight:800; }
        .decision { border: 2px dashed rgba(245,158,11,.55); background: linear-gradient(180deg, rgba(245,158,11,.10), rgba(255,255,255,.92)); }
        .pill { display:inline-flex; gap:8px; align-items:center; padding:8px 12px; border-radius:999px; background: rgba(15,118,110,.08); color:#0f766e; font-size:.85rem; font-weight:700; }
        .two-col { display:grid; grid-template-columns: 1.1fr .9fr; gap: 26px; align-items:stretch; }
        .card { background: rgba(255,255,255,.9); border: 1px solid rgba(15,23,42,.08); border-radius: 24px; padding: 24px; box-shadow: 0 12px 30px rgba(15,23,42,.06); }
        .io-table { width:100%; border-collapse:collapse; margin-top:14px; font-size:.94rem; }
        .io-table th, .io-table td { padding: 10px 12px; border-bottom: 1px solid rgba(15,23,42,.08); text-align:left; vertical-align:top; }
        .lane { display:grid; grid-template-columns: 180px 1fr; gap:16px; align-items:start; margin-top:16px; }
        .lane-label { padding:14px 16px; border-radius:18px; background: rgba(15,118,110,.1); font-weight:800; color:#0f766e; }
        .lane-body { display:grid; grid-template-columns: repeat(3,1fr); gap:14px; }
        .small-box { background:white; border:1px solid rgba(15,23,42,.08); border-radius:18px; padding:14px; min-height:104px; box-shadow:0 8px 20px rgba(15,23,42,.05); }
        .summary-grid { display:grid; grid-template-columns: repeat(4,1fr); gap:16px; margin-top:20px; }
        .metric { background: white; border:1px solid rgba(15,23,42,.08); border-radius:22px; padding:18px; box-shadow:0 8px 20px rgba(15,23,42,.05); }
        .metric .big { font-size: 1.8rem; font-weight: 800; color:#0f766e; }
        .process-band { display:grid; grid-template-columns: repeat(5, 1fr); gap: 10px; margin-top: 20px; }
        .process-step { background:white; border:1px solid rgba(15,23,42,.08); border-radius:18px; padding:14px; min-height: 110px; position:relative; }
        .process-step:after { content:'→'; position:absolute; right:-9px; top:42%; color:#0f766e; font-weight:800; }
        .process-step:last-child:after { content:''; }
        @media (max-width: 980px) {
          .flow-grid, .summary-grid, .process-band, .lane-body, .two-col { grid-template-columns: 1fr; }
          .lane { grid-template-columns: 1fr; }
          .arrow-note, .process-step:after { display:none; }
          .slide { padding-bottom: 120px; }
        }
      `}} />

      <div className="deck">
        <div className={`slide ${current === 1 ? 'active' : ''}`} data-slide="1">
          <div className="gradient-mesh">
            <div className="blob" style={{ width: 380, height: 380, top: -120, right: -90, background: '#38bdf8', opacity: 0.14 }}></div>
            <div className="blob" style={{ width: 280, height: 280, bottom: -60, left: -50, background: '#0f766e', opacity: 0.12 }}></div>
            <div className="blob" style={{ width: 220, height: 220, top: '38%', left: '22%', background: '#f59e0b', opacity: 0.08 }}></div>
          </div>
          <div className="content text-center">
            <div className="pill reveal mx-auto" style={{ width: 'fit-content' }}>Water Hydrant Automation Proposal</div>
            <h1 className="font-display text-[clamp(2.6rem,5.8vw,4.8rem)] font-extrabold tracking-tight mt-6 reveal">Tanker Filling Process Flow</h1>
            <p className="text-[clamp(1rem,1.8vw,1.3rem)] text-text-secondary mt-4 max-w-3xl mx-auto reveal">Flowchart and operating logic for PLC-SCADA controlled water dispatch with QR-based tanker request, metered filling, safety interlocks, and digital completion logging.</p>
            <div className="summary-grid reveal">
              <div className="metric"><div className="big">QR App</div><div>Driver starts request digitally at bay.</div></div>
              <div className="metric"><div className="big">PLC</div><div>Executes all interlocks and filling logic.</div></div>
              <div className="metric"><div className="big">SCADA</div><div>Monitors transactions, alarms, and reports.</div></div>
              <div className="metric"><div className="big">Flow Meter & Valve</div><div>Stops dispatch at target litres automatically.</div></div>
            </div>
          </div>
        </div>
        
        <div className={`slide ${current === 2 ? 'active' : ''}`} data-slide="2">
          <div className="gradient-mesh">
            <div className="blob" style={{ width: 320, height: 320, top: -70, right: -70, background: '#38bdf8', opacity: 0.08 }}></div>
            <div className="blob" style={{ width: 240, height: 240, bottom: -50, left: -40, background: '#0f766e', opacity: 0.08 }}></div>
          </div>
          <div className="content">
            <h2 className="font-display text-[clamp(2rem,4vw,3.2rem)] font-bold reveal">End-to-end working flow</h2>
            <p className="text-lg text-text-secondary mt-2 reveal">This slide can be used as the primary approval flowchart for the technical department.</p>
            <div className="flow-grid">
              <div className="flow-card reveal"><div className="num">1</div><h3 className="font-bold">Tanker arrives</h3><p>Tanker is parked at the assigned filling bay and hose connection is prepared.</p><div className="arrow-note">→</div></div>
              <div className="flow-card reveal"><div className="num">2</div><h3 className="font-bold">QR scan and request</h3><p>Driver scans QR code, opens app, enters tanker details and required litres.</p><div className="arrow-note">→</div></div>
              <div className="flow-card decision reveal"><div className="num">3</div><h3 className="font-bold">Validation check</h3><p>System checks customer authorization, balance, request limit, tanker mapping, and bay availability.</p></div>
              <div className="flow-card reveal"><div className="num">4</div><h3 className="font-bold">PLC permissives</h3><p>PLC checks E-stop healthy, valve healthy, communication OK, and bay ready.</p><div className="arrow-note">→</div></div>
              <div className="flow-card reveal"><div className="num">5</div><h3 className="font-bold">Valve opens</h3><p>Actuated valve opens and water starts flowing through hydrant line to tanker.</p><div className="arrow-note">→</div></div>
              <div className="flow-card reveal"><div className="num">6</div><h3 className="font-bold">Metered filling</h3><p>Flow meter sends pulse or analog quantity to PLC, while SCADA displays live fill status.</p></div>
              <div className="flow-card decision reveal"><div className="num">7</div><h3 className="font-bold">Target reached?</h3><p>If delivered volume equals set litres, PLC issues close command and ends batch.</p></div>
              <div className="flow-card reveal"><div className="num">8</div><h3 className="font-bold">Auto stop and log</h3><p>Valve closes, batch is completed, transaction is stored, and receipt/confirmation is generated.</p><div className="arrow-note">→</div></div>
              <div className="flow-card reveal"><div className="num">9</div><h3 className="font-bold">Tanker exits</h3><p>Driver disconnects, leaves bay, and station becomes available for next dispatch.</p></div>
            </div>
          </div>
        </div>
        
        <div className={`slide ${current === 3 ? 'active' : ''}`} data-slide="3">
          <div className="gradient-mesh">
            <div className="blob" style={{ width: 300, height: 300, top: -90, right: -40, background: '#f59e0b', opacity: 0.07 }}></div>
            <div className="blob" style={{ width: 260, height: 260, bottom: -60, left: -60, background: '#0f766e', opacity: 0.08 }}></div>
          </div>
          <div className="content">
            <h2 className="font-display text-[clamp(2rem,4vw,3rem)] font-bold reveal">Control architecture</h2>
            <div className="two-col mt-6">
              <div className="card reveal">
                <h3 className="font-bold text-xl">Functional blocks</h3>
                <div className="process-band">
                  <div className="process-step"><strong>App layer</strong><br/>QR scan, login, order entry, status screen.</div>
                  <div className="process-step"><strong>Server/API</strong><br/>Validates request, stores order, passes command.</div>
                  <div className="process-step"><strong>PLC panel</strong><br/>Interlocks, fill sequence, cut-off logic.</div>
                  <div className="process-step"><strong>Field devices</strong><br/>Flow meter, valve, E-stop, bay sensors.</div>
                  <div className="process-step"><strong>SCADA</strong><br/>Monitoring, alarms, trends, reports, audit trail.</div>
                </div>
                <p className="mt-5 text-text-secondary">Safety-critical control remains inside the PLC. The app only requests filling; it must not directly open or close the hydrant valve.</p>
              </div>
              <div className="card reveal">
                <h3 className="font-bold text-xl">Minimum panel I/O and signals</h3>
                <table className="io-table">
                  <tbody>
                    <tr><th>Type</th><th>Signals</th><th>Purpose</th></tr>
                    <tr><td>Digital inputs</td><td>E-stop, valve open/close feedback, bay ready, hose connected</td><td>Safety and sequence permissives</td></tr>
                    <tr><td>Analog / pulse</td><td>Flow meter</td><td>Quantity control</td></tr>
                    <tr><td>Digital outputs</td><td>Open valve, close valve, hooter, stack light</td><td>Command and indication</td></tr>
                    <tr><td>Comms</td><td>PLC to SCADA, PLC to gateway/API</td><td>Data exchange and remote reporting</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        
        <div className={`slide ${current === 4 ? 'active' : ''}`} data-slide="4">
          <div className="gradient-mesh">
            <div className="blob" style={{ width: 340, height: 340, top: -100, right: -60, background: '#38bdf8', opacity: 0.09 }}></div>
            <div className="blob" style={{ width: 260, height: 260, bottom: -80, left: -60, background: '#0f766e', opacity: 0.08 }}></div>
          </div>
          <div className="content">
            <h2 className="font-display text-[clamp(2rem,4vw,3rem)] font-bold reveal">Role-wise sequence</h2>
            <div className="lane reveal">
              <div className="lane-label">Driver / User</div>
              <div className="lane-body">
                <div className="small-box"><strong>Scan QR</strong><br/>Open station page from tanker bay code.</div>
                <div className="small-box"><strong>Enter litres</strong><br/>Submit required quantity and tanker details.</div>
                <div className="small-box"><strong>Wait and depart</strong><br/>Watch fill completion, receive confirmation, leave site.</div>
              </div>
            </div>
            <div className="lane reveal">
              <div className="lane-label">App / Server</div>
              <div className="lane-body">
                <div className="small-box"><strong>Authenticate</strong><br/>Validate user, tanker, account, and allowed quantity.</div>
                <div className="small-box"><strong>Create dispatch order</strong><br/>Send approved request to PLC/SCADA gateway.</div>
                <div className="small-box"><strong>Close transaction</strong><br/>Record actual litres, timestamps, and digital receipt.</div>
              </div>
            </div>
            <div className="lane reveal">
              <div className="lane-label">PLC / SCADA</div>
              <div className="lane-body">
                <div className="small-box"><strong>Check interlocks</strong><br/>E-stop OK, valve status OK, bay ready.</div>
                <div className="small-box"><strong>Execute filling</strong><br/>Open valve and totalize flow continuously to target litres.</div>
                <div className="small-box"><strong>Alarm & report</strong><br/>Close valve on completion or fault, then log batch and alarms.</div>
              </div>
            </div>
          </div>
        </div>
        
        <div className={`slide ${current === 5 ? 'active' : ''}`} data-slide="5">
          <div className="gradient-mesh">
            <div className="blob" style={{ width: 380, height: 380, top: -120, right: -90, background: '#0f766e', opacity: 0.12 }}></div>
            <div className="blob" style={{ width: 260, height: 260, bottom: -70, left: -50, background: '#f59e0b', opacity: 0.10 }}></div>
            <div className="blob" style={{ width: 200, height: 200, top: '44%', left: '22%', background: '#38bdf8', opacity: 0.08 }}></div>
          </div>
          <div className="content text-center">
            <div className="pill reveal mx-auto" style={{ width: 'fit-content' }}>For technical approval</div>
            <h2 className="font-display text-[clamp(2.4rem,5vw,4rem)] font-bold mt-5 reveal">Recommended approval note</h2>
            <div className="card max-w-4xl mx-auto mt-8 reveal" style={{ textAlign: 'left' }}>
              <p className="text-lg text-text-secondary">Approve a single-bay pilot system with QR-based user request, PLC-controlled hydrant filling, flow-meter-based litre cut-off, SCADA monitoring, and transaction logging. This architecture is scalable to multiple bays and keeps all safety and dispatch logic inside the PLC panel.</p>
              <div className="summary-grid" style={{ gridTemplateColumns: 'repeat(3,1fr)' }}>
                <div className="metric"><div className="big">Safe</div><div>PLC owns interlocks and emergency shutdown.</div></div>
                <div className="metric"><div className="big">Measurable</div><div>Flow meter provides accurate volume dispatch.</div></div>
                <div className="metric"><div className="big">Scalable</div><div>Same logic can extend to more hydrant bays.</div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="nav-controls">
        <button className="nav-btn" onClick={() => changeSlide(-1)} aria-label="Previous slide">&#8249;</button>
        <div className="slide-dots" id="dots">
          {[...Array(totalSlides)].map((_, i) => (
            <div 
              key={i} 
              className={`dot ${current === i + 1 ? 'active' : ''}`} 
              onClick={() => goToSlide(i + 1)}
            ></div>
          ))}
        </div>
        <button className="nav-btn" onClick={() => changeSlide(1)} aria-label="Next slide">&#8250;</button>
        <span className="slide-counter" id="counter">{current} / {totalSlides}</span>
      </div>
    </>
  );
}

